exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".url_url_3I3v0 {\n    font-family: monospace;\n    -webkit-user-select: text;\n       -moz-user-select: text;\n        -ms-user-select: text;\n            user-select: text;\n    word-wrap: break-word;\n}\n.url_url_3I3v0::before {\n    content: '\"';\n}\n.url_url_3I3v0::after {\n    content: '\"';\n}\n", ""]);

// exports
exports.locals = {
	"url": "url_url_3I3v0"
};